"use client";

import React from "react";
import { CheckCircle2, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutOurCompany() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = ["Strategic Planning", "Operational Excellence", "Change Management", "Data-Driven Insights"];
  return <section data-section-id="224559" id="about-momentum" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-3"}`}>
            <div className="relative rounded-none overflow-hidden border border-border/30 shadow-xl shadow-secondary/5 group bg-card">
              {}
              <div className="absolute inset-0 bg-primary/5 group-hover:bg-transparent transition-colors duration-700 z-10 pointer-events-none" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/cabazon_tow_truck_landscape.png" alt="Momentum consulting team collaborating in a Perth office environment" className="w-full h-[400px] md:h-[600px] object-cover transition-transform duration-1000 group-hover:scale-105" />
              
              {}
              <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-secondary/30 z-20 m-4 pointer-events-none" />
              <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-secondary/30 z-20 m-4 pointer-events-none" />
            </div>
            
            {}
            <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-secondary rounded-md -z-10 pointer-events-none opacity-10" />
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out delay-200 ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <h2 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold uppercase tracking-tighter text-foreground leading-[0.9]">
                Momentum. <br className="hidden md:block" />
                <span className="text-primary">Growth.</span> <br className="hidden md:block" />
                Clarity.
              </h2>
              <p className="font-mono text-lg md:text-xl text-muted-foreground font-medium uppercase tracking-widest border-l-4 border-primary pl-4">Momentum ConsultANTS</p>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground font-sans leading-relaxed">
              <p>
                Based in Perth, we provide high-impact consulting services designed to drive measurable growth. Our approach combines technical clarity with strategic foresight to solve your most complex business challenges with absolute precision.
              </p>
              <p>
                Our team of experts works in a highly collaborative environment, ensuring that every solution is tailored to your unique operational needs. From <strong className="text-foreground font-semibold">digital transformation</strong> to <strong className="text-foreground font-semibold">market expansion</strong>, we deliver the momentum your business deserves.
              </p>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-4 border-y border-border/50">
              {features.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-3">
                  <CheckCircle2 className="size-5 text-primary shrink-0" />
                  <span className="font-medium text-foreground tracking-wide font-sans">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button size="lg" className="text-lg font-default font-bold uppercase tracking-wide h-14 px-8 w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90" asChild>
                <Link to="tel:0417268353">
                  <Phone className="mr-2 size-5" />
                  Book a Call
                </Link>
              </Button>
              <Button variant="outline" size="lg" className="text-lg font-default font-bold uppercase tracking-wide h-14 px-8 w-full sm:w-auto border-border hover:bg-accent hover:text-accent-foreground" asChild>
                <Link to="mailto:Robert@momentumconsultants.com">
                  <MapPin className="mr-2 size-5" />
                  Contact Us
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}